// extracted by mini-css-extract-plugin
module.exports = {"teamsListing":"style_teamsListing__eAbWV"};